import type { Module } from "@webmotors/ioc";
import { GeolocationCookieModule, LeadFormDataModule } from "../cookies";
import { AdobeService } from "./adobe.service";

export const AdobeModule: Module = {
  name: "AdobeModule",
  modules: [LeadFormDataModule, GeolocationCookieModule],
  providers: [AdobeService],
};
